(() => {
  function initialize(section) {
    if (!section || section.dataset.ivnoReady === 'true') return;
    section.dataset.ivnoReady = 'true';

    const items = [...section.querySelectorAll('.ivno-collections-directory__item')];
    if (!items.length || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    section.classList.add('ivno-motion-ready');
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        const item = entry.target;
        item.classList.add('is-visible');
        observer.unobserve(item);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });

    items.forEach((item, index) => {
      item.style.transitionDelay = `${Math.min(index % 2, 1) * 90}ms`;
      observer.observe(item);
    });
  }

  function start(root = document) {
    root.querySelectorAll('.ivno-collections-directory').forEach(initialize);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => start(), { once: true });
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', (event) => start(event.target));
})();
